export interface Task {
    text: Record<string, string>;
}
